// extracted by mini-css-extract-plugin
export default {"paperContent":"Drawer_paperContent__XyH-r","content":"Drawer_content__+Zs0C"};